import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import AccordionSection from '../AccordionSection'

import AggregationReverseETLImage from './AggregationReverseETLImage'

const data = {
  anchorId: `reverse-etl`,
  overline: `Warehouse data activation`,
  heading: `Reverse ETL`,
  description: `Bring enriched data from your warehouse and activate it anywhere. Reverse ETL makes it easy for data teams to get marketers access to the data they need to build.`,
  buttonTextLink: `/product/reverse-etl/`,
  buttonTextLinkText: `Explore Reverse ETL`,
  accordionSection: SectionWithAccordion.REVERSE_ETL,
}

const AggregationReverseETL: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()
  const { anchorId, overline, heading, description, buttonTextLink, buttonTextLinkText, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <Spacer>{description}</Spacer>
            </CopyText.Description>
            <AccordionSection section={accordionSection} />
            <TopSpacer>
              <ButtonText tag="a" href={getAbsoluteUrl(buttonTextLink, pageConfig)} iconEnd={ChevronRightIcon}>
                {buttonTextLinkText}
              </ButtonText>
            </TopSpacer>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <AggregationReverseETLImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const TopSpacer = styled.div`
  margin-top: 32px;
`

const Spacer = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default AggregationReverseETL
